import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from "mobx-react";
import store from "./Store";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter } from 'react-router-dom';
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';
import { MicroAgent } from '@newrelic/browser-agent/src/loaders/micro-agent';

// NR browser agent options

// Populate using values in copy-paste JavaScript snippet
// "Training App"
const options = {
  init: {privacy:{cookies_enabled:false},ajax:{deny_list:["bam.eu01.nr-data.net"]},proxy:{assets: "nrproxy.pixiespace.ie"},  feature_flags: ['soft_nav']}, // NREUM.init
  info: {beacon:"bam.eu01.nr-data.net",errorBeacon:"bam.eu01.nr-data.net",licenseKey:"NRJS-c144e1466ea45ab20e7",applicationID:"538609181",sa:1}, // NREUM.info
  loader_config: {accountID:"3659611",trustKey:"3659611",agentID:"538609181",licenseKey:"NRJS-c144e1466ea45ab20e7",applicationID:"538609181"} // NREUM.loader_config
}


// NR1 "sfrazier-test-app"
/*
const options = {
	init:{
		privacy:{
			cookies_enabled:false
		},
		// feature configurations
		ajax: {
			autoStart: false, 
			deny_list:["bam.nr-data.net"]
		},
		jserrors: {autoStart: false},
		metrics: {autoStart: false},
		generic_events: {autoStart: false},
		page_view_event: {autoStart: false},
		page_view_timing: {autoStart: false},
		session_replay: {autoStart: false},
		session_trace: {autoStart: false},
		spa: {autoStart: false},
		logging: {autoStart: false} 
	},
	loader_config:{accountID:"1",trustKey:"1",agentID:"601534260",licenseKey:"NRBR-831606d506bdf5cdc0b",applicationID:"601534260"},
	info:{beacon:"bam.nr-data.net",errorBeacon:"bam.nr-data.net",licenseKey:"NRBR-831606d506bdf5cdc0b",applicationID:"601534260",sa:1}
}
*/

// The agent loader code executes immediately on instantiation.
// new BrowserAgent(options)
new MicroAgent(options)


const stores = {
  store
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider {...stores}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
